"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var getWidth = function getWidth(element) {
  var cs = getComputedStyle(element);
  var paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
  var borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
  return element.offsetWidth - paddingX - borderX;
};

var synchronizeCellSizes = function synchronizeCellSizes(node) {
  var wrappers = node.querySelectorAll('section');
  wrappers.forEach(function (wrapper) {
    var tables = wrapper.querySelectorAll('table');
    var cellArrays = (0, _toConsumableArray2.default)(tables).map(function (table) {
      return table.querySelectorAll('tr:first-child td');
    });
    cellArrays[0].forEach(function (cell0, i) {
      var cell1 = cellArrays[1][i];
      var maxWidth = Math.max(getWidth(cell0), getWidth(cell1)) + 'px';
      cell0.style.minWidth = maxWidth;
      cell1.style.minWidth = maxWidth;
    });
  });
};

var _default = synchronizeCellSizes;
exports.default = _default;